import { CacheableDataObject } from './CacheableDataObject';
import { ChatMessageNotification } from './ChatMessage';
import { ChatActions } from '../components/ChatActions';

export default class FriendData extends CacheableDataObject {
	beforeConstruct() {
		this.is_friend = null;
		this.request_sent = null;
		this.waiting_response = null;
	}

	isPending() {
		if(this.is_friend) {
			return false;
		}
		return (this.request_sent || this.waiting_response);
	}

}